import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ConsoleAuthContext = createContext(null);

export const ConsoleAuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/auth/me`, { withCredentials: true })
      .then(({ data }) => {
        if (data.role === "admin") setAdmin(data);
        else setAdmin(null);
      })
      .catch(() => setAdmin(null))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
      if (data.role !== "admin") {
        await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
        return { success: false, error: "Access denied. Admin credentials required." };
      }
      setAdmin(data);
      return { success: true };
    } catch (e) {
      return { success: false, error: e.response?.data?.detail || "Login failed" };
    }
  };

  const logout = async () => {
    await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    setAdmin(null);
  };

  return (
    <ConsoleAuthContext.Provider value={{ admin, loading, login, logout }}>
      {children}
    </ConsoleAuthContext.Provider>
  );
};

export const useConsoleAuth = () => {
  const ctx = useContext(ConsoleAuthContext);
  if (!ctx) throw new Error("useConsoleAuth must be used inside ConsoleAuthProvider");
  return ctx;
};
